export default __webpack_public_path__ + "static/media/ps5-desktop.93231414.png";